import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const RECRUITMENT_NEWS_ITEMS = [
    "Wist je dat 73% van de kandidaten afhaakt bij een te lang sollicitatieproces?",
    "Nieuwe trend: AI neemt steeds meer administratieve HR-taken over in 2026.",
    "Werkzoekenden hechten in 2026 meer waarde aan flexibiliteit dan aan salaris.",
    "De IT-sector kampt nog steeds met het grootste tekort aan gekwalificeerd personeel.",
    "Tip: Een persoonlijke onboarding video verhoogt retentie met 40% in de eerste maand.",
    "Recruitment marketing via TikTok is de snelst groeiende strategie voor Gen Z.",
    "Wist je dat Werfplaats AI vacatureteksten in seconden 100% inclusief kan herschrijven?"
];

const GlobalLoader: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [newsIndex, setNewsIndex] = useState(0);

    useEffect(() => {
        const handleShow = (e: any) => {
            setMessage(e.detail || 'Laden...');
            setIsVisible(true);
        };
        const handleHide = () => {
            setIsVisible(false);
            setMessage('');
        };

        window.addEventListener('showGlobalLoader', handleShow);
        window.addEventListener('hideGlobalLoader', handleHide);

        return () => {
            window.removeEventListener('showGlobalLoader', handleShow);
            window.removeEventListener('hideGlobalLoader', handleHide);
        };
    }, []);

    useEffect(() => {
        if (!isVisible) return;
        const interval = setInterval(() => {
            setNewsIndex(prev => (prev + 1) % RECRUITMENT_NEWS_ITEMS.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.1)] border border-slate-200 p-6 w-[340px] flex flex-col items-center animate-slideUp">
            <div className="w-12 h-12 bg-red- rounded-full flex items-center justify-center mb-4 text-red-">
                <Loader2 className="animate-spin" size={24} />
            </div>

            <h3 className="text-sm font-black text-slate-900 mb-2 truncate w-full text-center">
                {message}
            </h3>

            <div className="flex flex-col items-center text-center w-full mt-2 pt-4 border-t border-slate-100">
                <h4 className="text-[10px] font-black text-red- uppercase tracking-widest mb-2">Actueel Recruitment Nieuws</h4>
                <p className="text-xs text-slate-500 font-medium leading-relaxed italic min-h-[48px] flex items-center justify-center transition-opacity duration-500" key={newsIndex}>
                    "{RECRUITMENT_NEWS_ITEMS[newsIndex]}"
                </p>
            </div>
        </div>
    );
};

export default GlobalLoader;
